import store from 'mt-react-common/createStore';

import mainModuleRegistry from 'mt-react-common/modules/main/reducers/static/combineRegistry';
import tasksModuleRegistry from 'mt-react-common/modules/tasks/reducers/static/combineRegistry';
import usersModuleRegistry from 'mt-react-common/modules/users/reducers/static/combineRegistry';
import promotionalMaterialsModuleRegistry from 'mt-react-common/modules/promotionalMaterials/reducers/static/combineRegistry';
import userReferralModuleRegistry from 'mt-react-common/modules/userReferral/reducers/static/combineRegistry';
import userDaysStatModuleRegistry from 'mt-react-common/modules/userDaysStat/reducers/static/combineRegistry';
import infoMaterialsModuleRegistry from 'mt-react-common/modules/infoMaterials/reducers/static/combineRegistry';
import authUserOutputCashModuleRegistry from 'mt-react-common/modules/authUserOutputCash/reducers/static/combineRegistry';
import userFlowFundsModuleRegistry from 'mt-react-common/modules/userFlowFunds/reducers/static/combineRegistry';
import userRatingModuleRegistry from 'mt-react-common/modules/userRating/reducers/static/combineRegistry';
import eventsModuleRegistry from 'mt-react-common/modules/events/reducers/static/combineRegistry';
import faqContentsModuleRegistry from 'mt-react-common/modules/faqContents/reducers/static/combineRegistry';
import feedbackModuleRegistry from 'mt-react-common/modules/feedback/reducers/static/combineRegistry';
import userBlackListModuleRegistry from 'mt-react-common/modules/userBlackList/reducers/static/combineRegistry';
import topUsersModuleRegistry from 'mt-react-common/modules/topUsers/reducers/static/combineRegistry';
import specialPagesModuleRegistry from 'mt-react-common/modules/specialPages/reducers/static/combineRegistry';
import contestsModuleRegistry from 'mt-react-common/modules/contests/reducers/static/combineRegistry';
// import i18nModuleRegistry from 'mt-react-common/modules/i18n/reducers/static/combineRegistry';
import localeModuleRegistry from 'mt-react-common/modules/locale/reducers/static/combineRegistry';
import messengerModuleRegistry from 'mt-react-common/modules/messenger/reducers/static/combineRegistry';

mainModuleRegistry();
tasksModuleRegistry();
usersModuleRegistry();
promotionalMaterialsModuleRegistry();
userDaysStatModuleRegistry();
userReferralModuleRegistry();
infoMaterialsModuleRegistry();
authUserOutputCashModuleRegistry();
userFlowFundsModuleRegistry();
userRatingModuleRegistry();
eventsModuleRegistry();
faqContentsModuleRegistry();
feedbackModuleRegistry();
userBlackListModuleRegistry();
topUsersModuleRegistry();
specialPagesModuleRegistry();
contestsModuleRegistry();
// i18nModuleRegistry();
localeModuleRegistry();
messengerModuleRegistry();
export default store;



// WEBPACK FOOTER //
// ./src/store.js